// extracted by mini-css-extract-plugin
module.exports = {"definition":"VideoComponent__definition","chapter-button-size":"VideoComponent__chapter-button-size","hide":"VideoComponent__hide","is360":"VideoComponent__is360","root":"VideoComponent__root","videoJs":"VideoComponent__videoJs","canvasRendering":"VideoComponent__canvasRendering"};
    if(module.hot) {
      // 1790535732694
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  